<template>
    <i :class="`fas ${icon}`" />
</template>

<script>
export default {
    name: 'ObjectiveLevelIcon',
    props: {
        objectiveLevel: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            iconsForEachLevel: {
                personal: 'fa-user',
                department: 'fa-users',
                unit: 'fa-industry',
            },
        }
    },
    computed: {
        icon() {
            return this.iconsForEachLevel[this.objectiveLevel]
        },
    },
}
</script>
